import { render, staticRenderFns } from "./HospitalLevel.vue?vue&type=template&id=1dd79fcc&scoped=true&"
import script from "./HospitalLevel.vue?vue&type=script&lang=js&"
export * from "./HospitalLevel.vue?vue&type=script&lang=js&"
import style0 from "./HospitalLevel.vue?vue&type=style&index=0&id=1dd79fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd79fcc",
  null
  
)

export default component.exports